import { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_MST3040_R01 } from "./Content_MST3040_R01";
import { SearchSection_MST3040_R01 } from "./SearchSection_MST3040_R01";
import { useMST3040_R01Store } from "./Store_MST3040_R01";
import { AgGridReact } from "ag-grid-react";
import { MST3040_R01DetailDto, MST3040_R01Dto, MST3040_R01HeaderDto, MST3040_R01UsageDto } from "./Dto_MST3040_R01";
import { Table_MST3040_R01 } from "./Table_MST3040_R01";
import { DetailTable_MST3040_R01 } from "./DetailTable_MST3040_R01";
import { Modal_MST3040_R01 } from "./Modal_MST3040_R01";


export const Container_MST3040_R01 = () => {

	const { 
		allCount,
		initData, 
		modalVisible,	setModalVisible,
	} = useMST3040_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'MST3040_R01',
		type: 'width',
		storageKey: 'MST3040_R01-split-width',
		min: 5,
		max: 80,
		default: 35
	} as const;
	const gridRef = useRef<AgGridReact<MST3040_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<MST3040_R01DetailDto>>(null);
	const usageGridRef = useRef<AgGridReact<MST3040_R01UsageDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		clickable, setClickable,
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultMST3040_R01DetailRow,
		defaultMST3040_R01UsageRow,
		initContainerData,
		handleInsertClick,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_MST3040_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_MST3040_R01 />
		<Modal_MST3040_R01
			usageGridRef={usageGridRef}
			defaultMST3040_R01UsageRow={defaultMST3040_R01UsageRow()}
			handleDeleteClick={handleDeleteClick}
		/>

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_MST3040_R01 gridRef={gridRef} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<DetailTable_MST3040_R01 gridRef={detailGridRef} defaultMST3040_R01DetailRow={defaultMST3040_R01DetailRow()} />
			</div>
		</div>
		<Message />
	</div>
}